module.exports = __webpack_public_path__ + "img/xgpfqjys1.b45d0526.png";